import { render, staticRenderFns } from "./experimentguide.vue?vue&type=template&id=58f570bf&scoped=true&"
import script from "./experimentguide.vue?vue&type=script&lang=js&"
export * from "./experimentguide.vue?vue&type=script&lang=js&"
import style0 from "./experimentguide.vue?vue&type=style&index=0&id=58f570bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f570bf",
  null
  
)

export default component.exports